import {graphql} from 'react-relay'

export const query = graphql`
  query AddRepositoryPageQuery($locator: String!, $skip: Boolean!) {
    pipeline(pipelineLocator: $locator) @skip(if: $skip) {
      parentProject {
        ...pipelineParentProjectFragment
      }
    }
  }
`
